/*
  NAVEE 定制：底部固定条里的锚点导航。
  - 平滑滚动（偏移交给 CSS 的 scroll-margin-top，不在这里算）
  - 当前所在 section 高亮，用 IntersectionObserver 而不是 scroll 事件
*/
(function () {
  function init() {
    var nav = document.querySelector('[data-sticky-nav]');
    if (!nav || nav.dataset.stickyNavInit === '1') return;
    nav.dataset.stickyNavInit = '1';

    var links = Array.prototype.slice.call(nav.querySelectorAll('[data-sticky-nav-link]'));
    var targets = [];

    // Liquid 已经把 id 拼成 shopify-section-template--<主题号>__<键名>。
    // 但如果设置里粘的是从别的主题/预览复制来的完整 id，那串主题号就对不上了，
    // 所以再按键名（最后一段 __xxx）兜底找一次。
    function resolve(link) {
      var id = link.getAttribute('href').slice(1);
      var el = document.getElementById(id);
      if (el) return el;

      var key = id.replace(/^shopify-section-/, '').split('__').pop();
      if (!key) return null;

      return document.querySelector('[id$="__' + key + '"]') || document.getElementById(key);
    }

    links.forEach(function (link) {
      var el = resolve(link);
      if (el) {
        // 用真实存在的 id 回写，:target 之类的原生行为才对得上
        link.setAttribute('href', '#' + el.id);
        targets.push({ link: link, el: el });
      } else {
        // 目标 section 不在这个模板里（或 ID 填错了）——把链接去掉，
        // 免得点了没反应。
        var item = link.closest('.sticky-nav__item');
        if (item) item.remove();
      }
    });

    if (targets.length === 0) return;

    targets.forEach(function (target) {
      target.link.addEventListener('click', function (event) {
        event.preventDefault();
        target.el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    // 判定「越过判定线的最后一个」要按页面顺序来，而导航里的排列顺序是人填的，
    // 两者不一定一致（好几个模板里 FAQ 就排在 recommendations 后面）。
    var ordered = targets.slice().sort(function (a, b) {
      return a.el.compareDocumentPosition(b.el) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
    });

    var list = nav.querySelector('.sticky-nav__list');

    // 当前项横向居中。手机上放不下时，后面的条目本来看不到也点不到，
    // 页面滚到那一段时把它带进视野。
    function revealActive(link) {
      if (!list || list.scrollWidth <= list.clientWidth) return;

      var listRect = list.getBoundingClientRect();
      var linkRect = link.getBoundingClientRect();
      var delta = linkRect.left - listRect.left - (listRect.width - linkRect.width) / 2;
      if (Math.abs(delta) < 1) return;

      list.scrollTo({ left: list.scrollLeft + delta, behavior: 'smooth' });
    }

    var activeEl = null;
    var setActive = function (entry) {
      if (entry === activeEl) return;
      activeEl = entry;

      targets.forEach(function (t) {
        var isActive = t.el === entry;
        t.link.classList.toggle('is-active', isActive);
        if (isActive) revealActive(t.link);
      });
    };

    // 当前项 = 顶边已经越过判定线的最后一个目标，而不是「可见面积最大的那个」。
    // 后者会让短板块（比如 reviews）只在自己那一小段里高亮，它和下一个目标
    // 之间那些不在导航里的板块（image banner、feature cards…）就没有任何高亮。
    // 判定线取 header 底边下方 16px，和 CSS 里的 scroll-margin-top 对齐，
    // 这样点完链接落位时那一项正好就是当前项。
    function currentTarget() {
      var line =
        parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
      line += 17;

      var current = null;
      ordered.forEach(function (t) {
        if (t.el.getBoundingClientRect().top <= line) current = t;
      });

      // 滚到页面底部时，最后一段往往顶不到判定线，直接给最后一项。
      if (window.innerHeight + window.scrollY >= document.body.scrollHeight - 2) {
        current = ordered[ordered.length - 1];
      }

      return current ? current.el : null;
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        setActive(currentTarget());
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
